import { SURVEY_STATUS } from '@ps/survey-kernel';

import { Survey } from '../models/survey.model';

export class SurveyStatusInfo {
  public static isDraft(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.DRAFT;
  }

  public static isScheduled(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.SCHEDULED;
  }

  public static isLive(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.LIVE;
  }

  public static isPaused(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.PAUSED;
  }

  public static isClosed(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.CLOSED;
  }

  public static isInvoiced(survey: Survey): boolean {
    return survey.status === SURVEY_STATUS.INVOICED;
  }

  public static isLaunched(survey: Survey): boolean {
    return (
      !SurveyStatusInfo.isDraft(survey) && !SurveyStatusInfo.isScheduled(survey)
    );
  }
}
